// Import Dependencies
import React from 'react';

// Components
import Button from '../Button';
import MonthSlider from '../MonthSlider';

// Import Utilities
import { isMediaMatched } from '../../../utils';

const handleHideCalendar = () => {
  const calendar = document.getElementById('calendar');
  window.history.replaceState(null, '', window.location.pathname);

  if (calendar.classList.contains('is-open')) {
    calendar.classList.remove('is-open');
    document.body.classList.toggle('has-calendar-open');
  }
};

const SideBar = ({ ...props }) => {
  const mediaQuery = isMediaMatched(1200);

  return (
    <div className="c-calendar__sidebar">
      {mediaQuery && (
        <Button icon close onClick={handleHideCalendar}>
          <span className="u-visually-hidden">Close calendar</span>
        </Button>
      )}

      <MonthSlider {...props} />
    </div>
  );
};

export default SideBar;
